// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import './polyfill'
// import cssVars from 'css-vars-ponyfill'
import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import App from './App'
import {store} from '@/_store'
import router from './router/'

// todo
// cssVars()

Vue.use(BootstrapVue)

router.beforeEach((to, from, next) => {
  document.title = to.meta.title || to.meta.label || to.name;
  next()
})

new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: {
    App
  }
})
